<template>
    <toolbar-option>
        <template slot="primary">
            <input v-model="value" type="text" @change="setChangedData(true)">
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'date-format';

export default {
    name: 'date-format',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Date Format',
            value: '',
        };
    },

    watch: {
        value() {
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.value);
            this.onOptionChange(this.value);
            this.setChangedData(true);
        },
    },

    methods: {
        onSelectedElement() {
            this.value = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME);
        },
    },
};
</script>
